"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DpNavigationTabs = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var react_bootstrap_1 = require("react-bootstrap");
var findIndex_1 = __importDefault(require("lodash/findIndex"));
var DpNavigationTabs_styled_1 = require("./DpNavigationTabs.styled");
var link_1 = __importDefault(require("next/link"));
var createNavItems = function (elements, selectTab, elementsToShow, isLoading) {
    return elements.slice(0, elementsToShow).map(function (tabElement, index) {
        var indexLink = "link-".concat(index);
        var props = {
            'aria-selected': tabElement.active,
            className: 'text-center text-truncate text-size-md',
            disabled: isLoading,
            eventKey: indexLink,
            id: "tab-".concat(tabElement.id),
            onClick: !isLoading && selectTab(tabElement),
            role: 'tab',
            ref: tabElement.tabRef,
            as: link_1.default,
            legacyBehavior: false,
            href: '#',
            prefetch: false,
        };
        if (tabElement.ariaLabel)
            props['aria-label'] = tabElement.ariaLabel;
        return ((0, react_1.createElement)(react_bootstrap_1.Nav.Link, __assign({}, props, { key: tabElement.id }), tabElement.label));
    });
};
/**
 * DpNavigationTabs
 * @property {Array}       elements          - List of elements(dots) to show
 * @property {Function}    selectionHandler  - Callback fired when the tab element is selected
 * @property {number}      elementsToShow    - Number of elements to show
 *
 */
var DpNavigationTabs = function (_a) {
    var elements = _a.elements, selectionHandler = _a.selectionHandler, _b = _a.elementsToShow, elementsToShow = _b === void 0 ? elements.length : _b, _c = _a.isLoading, isLoading = _c === void 0 ? false : _c;
    var selectTab = function (tabElement) { return function () { return selectionHandler(tabElement); }; };
    var items = createNavItems(elements, selectTab, elementsToShow, isLoading);
    var activeIndex = (0, findIndex_1.default)(elements, function (element) { return element.active === true; });
    return ((0, jsx_runtime_1.jsx)(DpNavigationTabs_styled_1.StyledNavTabs, { defaultActiveKey: activeIndex > 0 ? "link-".concat(activeIndex) : 'link-0', className: "nav-tabs p-0 w-100 border-0", role: "tablist", "data-testid": "DpNavigationTabs", children: items }));
};
exports.DpNavigationTabs = DpNavigationTabs;
exports.default = exports.DpNavigationTabs;
